<template>
  <div
    class="tab-pane fade active show"
    id="activity-hour-content"
    role="tabpanel"
    aria-labelledby="pills-genarel-tab"
  >
    <form class="row g-3">
      <div class="col-md-4">
        <label class="form-label">資料開始時間</label>
        <datetime
          input-class="form-control"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          :phrases="{ ok: '確認', cancel: '取消' }"
          :minute-step="60"      
          :max-datetime="maxSelectTime"
          :auto="true"
          v-model="startTime"
          @focus="updateMaxSelectTime"
        >
        </datetime>
      </div>

      <div class="col-md-4">
        <label class="form-label">資料結束時間</label>
        <datetime
          input-class="form-control"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          :phrases="{ ok: '確認', cancel: '取消' }"
          :minute-step="59"
          :max-datetime="maxSelectTime"
          :auto="true"
          v-model="endTime"
          @focus="updateMaxSelectTime"
        >
        </datetime>
      </div>

      <div class="col-md-6 col-lg-4 d-flex align-items-end">
        <button
        type="button"
          class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
          @click="queryElk"
          :disabled="isWaitResult"
        >
          <i class="fas fa-search"></i> 查詢
      </button>
        <button
          type="button"
          class="btn btn-primary btn-sm rounded-pill px-3 mx-1"
          @click="exportCSV"
          :disabled="isWaitResult"
        >
          <i class="fas fa-share"></i> 匯出
    </button>
      </div>
    </form>

    <h1 style="margin-top: 0px">活動分時查詢結果</h1>

    <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
      <div class="col-12 order-2  ">
        <div class="card card-clean h-100">
          <div class="bd-example">
            <table
              id="activity-hour"
              class="w3-table-all table table-hover table-striped"
            >
              <thead class="table-dark">
                <tr>
                  <!-- <th scope="col" width="5%">#</th> -->
                  <th scope="col">時間</th>
                  <th scope="col">活動</th>
                  <th scope="col">在園人數</th>
                  <th scope="col">進場人數</th>
                  <th scope="col">離場人數</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, key) in dataTableList"
                  :key="key"
                  :class="tableCenterStyle"
                >
                  <!-- <td>{{ key + 1 }}</td> -->
                  <td style="white-space: pre-line">{{ getTime(item) }}</td>
                  <td>{{ item.activityName }}</td>
                  <td>{{ item.realTotalPeopleStay }}</td>
                  <td>{{ item.peopleIn }}</td>
                  <td>{{ item.peopleOut }}</td>
                </tr>
                <tr v-if="dataTableList.length > 0" :class="tableCenterStyle">
                  <td>統計</td>
                  <td></td>
                  <td>{{ totalStay }}</td>
                  <td>{{ totalIn }}</td>
                  <td>{{ totalOut }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-12 order-1  mt-5">
      <div id="activityHourChart">
        <apexchart
          type="area"
          height="200"
          :options="activtyHourSetting"
          :series="activtyHourCountStayData"
        ></apexchart>
      </div>
    </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import exportCSV from "../../utils/exportCSV";
import { getCountPerDay } from "../../api/elasticSearch/peopleApis";
import ApexchartObject from "../../utils/apexchartObject/searchActivity";

export default {
  name: "SearchActivity",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tableStyle: "w3-table-all table table-hover table-striped",
      tableThStyle: "table-dark",
      tableCenterStyle: "text-center",
      table: null,
      startTime: moment().startOf("day").format(),
      endTime: moment().startOf("minute").format(),
      dataTableList: [],
      activtyHourCountData: [],
      activtyHourCountStayData: [],
      activityDataList: [],
      chartDataList: [],
      activtyHourSetting: ApexchartObject.activityHourOption,
      totalStay: 0,
      totalIn: 0,
      totalOut: 0,
      isWaitResult:false,
      maxSelectTime: Utils.getLastestTime(),
    };
  },
  computed: {
    ...mapState("activity", { activityList: "activities" }),

    // maxSelectTime() {
    //   return moment().startOf("h").toISOString();
    // },
  },
  watch: {},
  methods: {
    async exportCSV() {
      this.isWaitResult = true;
      const list = await this.searchElk();
      if (Utils.isEmptyObject(list)) {
        return;
      }
      const csvContent = [["時間", "活動", "在園人數", "進場人數", "離場人數"]];
      list.forEach((item) => {
        const row = [];
        row.push(this.getTime(item));
        row.push(item.activityName);
        row.push(item.realTotalPeopleStay);
        row.push(item.peopleIn);
        row.push(item.peopleOut);
        csvContent.push(row);
      });
      const fileName = `CSV_${moment(this.startTime).format(
        "YYYY/MM/DD HH:mm"
      )}_活動分時查詢.csv`;
      exportCSV.genCSVFile(csvContent, fileName);
      this.isWaitResult = false;

    },

    async queryElk() {
      this.isWaitResult = true;

      this.dataTableList = await this.searchElk();
      // console.log("ELK", this.activityDataList);
      this.updateTable();
      // this.chartDataList = await this.getChartData();
      //圖表使用的 data 是搜尋0-24小時的資料，但 datatable 的 data 僅為搜尋時間內的資料
      // this.setChartData(this.chartDataList)
      this.setChartData(this.dataTableList);
      this.isWaitResult = false;

    },

    async searchElk() {
        this.totalStay = 0;
        this.totalIn = 0;
        this.totalOut = 0;
      if (
        Utils.isEmptyObject(this.startTime) ||
        Utils.isEmptyObject(this.endTime)
      ) {
        alert("請選擇起訖時間");
        return;
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert("結束時間不可以小於開始時間");
        return;
      }

      // if (moment(this.endTime).date() !== moment(this.startTime).date()) {
      //   alert("不可以跨天查詢");
      //   return;
      // }

      await this.searchActivities();
      //1. 找尋時間內的所有活動
      //2. 用活動的資料去搜尋時間內的人數
      //3. 查得活動的資料，搜尋該活動的全日分時人數
      // console.log("activityList",this.activityList)

      const st = moment(this.startTime).startOf("minute").valueOf();
      const et = moment(this.endTime).startOf("minute").valueOf();

      // const st = moment(this.startTime).startOf('day').valueOf()
      // const et = moment(this.endTime).endOf('day').valueOf()
      const data = this.activityList; //data為時間內的所有活動

      this.activityDataList = []; //重置每次搜尋傳入給 dataTable 的資料
      for (let i = 0; i < data.length; i++) {
        const st = moment(data[i].startDate).valueOf();
        const et = moment(data[i].endDate).valueOf();
        
        // console.log("st",moment(data[i].startDate).format());
        // console.log("et",moment(data[i].endDate).format());

        // const st = moment(data[i].startDate).format();
        // const et = moment(data[i].endDate).format();

        const condition1 = {
          streamingIds: [this.cctvPeopleIn[0].streamId],
          startTime: st,
          endTime: et,
          interval: "1h",
          objectTypes: [],
          dataType: "",
        };

        const condition2 = {
          streamingIds: [this.cctvPeopleOut[0].streamId],
          startTime: st,
          endTime: et,
          interval: "1h",
          objectTypes: [],
          dataType: "",
        };

        // console.log("condition1", condition1);
        // console.log("condition2", condition2);
        const result1In = await getCountPerDay(
          Object.assign({ message: "(in)" }, condition1)
        ); //入口進入
        const result1Out = await getCountPerDay(
          Object.assign({ message: "(out)" }, condition1)
        ); //入口出去

        const result2In = await getCountPerDay(
          Object.assign({ message: "(in)" }, condition2)
        ); //出口出去
        const result2Out = await getCountPerDay(
          Object.assign({ message: "(out)" }, condition2)
        ); //出口進入

        // 查詢範圍間隔
        const hours = moment(et).add(1, "minutes").diff(moment(st), "hours"); //for datatable

        //該活動當天24小時 (基準計算判斷)
        
        const alltimestamps = Array.from({ length: 24 }).map((_, i) => {
          return moment(st).startOf("day").add( i, "hours").valueOf();
        });
        
        //該活動實際舉辦時間
        const timestamps = Array.from({ length: hours }).map((_, i) => {
          return moment(st).add( i, "hours").valueOf();
        });

        // const timestamps = Array.from({ length: 12 }).map((_, i) => {
        //   return moment(st).add(12 + i, "hours").format();});


        // console.log("hours", hours);
        // console.log("timestamps ", timestamps);
        // console.log("alltimestamps", alltimestamps);

      
        if (
          Utils.isEmptyObject(result1In) &&
          Utils.isEmptyObject(result1Out) &&
          Utils.isEmptyObject(result2In) &&
          Utils.isEmptyObject(result2Out)
        ) {
          // alert("無活動");
        }

        const entranceInCount = timestamps.map((t) => {
          return result1In[t] ? result1In[t] : 0;
        });
        const entranceOutCount = timestamps.map((t) => {
          return result1Out[t] ? result1Out[t] : 0;
        });

        const exitInCount = timestamps.map((t) => {
          return result2In[t] ? result2In[t] : 0;
        });
        const exitOutCount = timestamps.map((t) => {
          return result2Out[t] ? result2Out[t] : 0;
        });


        let realTotalPeopleStay = 0;// 以空值存入各時段實際活動在園人數

        let dataList = alltimestamps.map((t, index) => {

          // 1. 若 timestamps.indexOf(t) ==-1 則表示該時間點非活動時間內
          // 2. 若 timestamps.indexOf(t)有值，則取該 index 的時間點資料進入 data
          
            const timeIndex = timestamps.indexOf(t);
            const isTimeExist = timeIndex !== -1;

            const peopleIn = isTimeExist ? entranceInCount[timeIndex] + exitOutCount[timeIndex] : 0;
            const peopleOut = isTimeExist ? entranceOutCount[timeIndex] + exitInCount[timeIndex] : 0;
            const realHourPeopleStay = peopleIn - peopleOut // 該時段進場-離場人數 (還原負值情況)
            realTotalPeopleStay = realTotalPeopleStay + realHourPeopleStay // 該時段實際在園人數 (還原負值情況 + 前時段進場-離場)

            const data = {
              time: t,
              timeTrans: moment(t).format("YYYY-MM-DD HH:mm:ss"),
              activityName: Utils.isEmptyObject(this.activityList[i]) ? "" : this.activityList[i].activityName,
              peopleStay: Math.max(peopleIn - peopleOut, 0),
              peopleIn: peopleIn,
              peopleOut: peopleOut,
              peopleRealStay: realHourPeopleStay, 
              realTotalPeopleStay: realTotalPeopleStay <0 ?0: realTotalPeopleStay
       
            };
           
            this.totalIn += data.peopleIn;
            this.totalOut += data.peopleOut;
            return data;
        });
        this.totalStay =
          this.totalIn - this.totalOut < 0 ? 0 : this.totalIn - this.totalOut;
        // console.log("dataList",dataList);
        this.activityDataList = this.activityDataList.concat(dataList);
      }
      return this.activityDataList;
    },

    setChartData(dataList) {
      this.activtyHourCountData = [];
      this.activtyHourCountStayData = [];

      //抽出相同活動的人數資料，個別組成物件
      for (let i = 0; i < this.activityList.length; i++) {

        const peopleStayCount = dataList
          .filter((d) => this.activityList[i].activityName === d.activityName)
          .map((d) => d.realTotalPeopleStay);

        const peopleInCount = dataList
          .filter((d) => this.activityList[i].activityName === d.activityName)
          .map((d) => d.peopleIn);

        const peopleOutCount = dataList
          .filter((d) => this.activityList[i].activityName === d.activityName)
          .map((d) => d.peopleOut);


        // console.log("aaa", peopleStayCount, peopleInCount, peopleOutCount);
        this.activtyHourCountData.push({
          name: `${moment(this.activityList[i].startDate)
            .format("YYYY-MM-DD HH:mm:ss")
            .split(" ")[0]}：${this.activityList[i].activityName} `,
          data: [peopleStayCount, peopleInCount, peopleOutCount],
          date: moment(this.activityList[i].startDate)
            .format("YYYY-MM-DD HH:mm:ss")
            .split(" ")[0],
        });
        this.activtyHourCountStayData.push({
          name: `${moment(this.activityList[i].startDate)
            .format("YYYY-MM-DD HH:mm:ss")
            .split(" ")[0]}：${this.activityList[i].activityName} `,
          data: peopleStayCount,
          date: moment(this.activityList[i].startDate)
            .format("YYYY-MM-DD HH:mm:ss")
            .split(" ")[0],
        });
    
      }
      // console.log("activtyHourCountData", this.activtyHourCountData);
      // console.log("activtyHourCountStayData", this.activtyHourCountStayData);

      let allData =  this.activtyHourCountData;
      let chartSetting = {...this.activtyHourSetting}
      chartSetting.tooltip.x.formatter = function (val) {
        // console.log("val",val)
        // let allpeopleInData = allData.data[1].date;//活動日期
        return ((val-1)+" 時"+ " ~ " +(val)+" 時")
      }
    
      
      chartSetting.tooltip.y.formatter = function (val,{ series, seriesIndex, dataPointIndex,w }) {

        let allpeopleInData = allData[seriesIndex].data[1][dataPointIndex]; // 進場人數
        let allpeopleOutCount = allData[seriesIndex].data[2][dataPointIndex]; // 離場人數
        // console.log( "ccc",allData[seriesIndex].data[1][dataPointIndex])

        return `
            【在園人數：${val} 人】
            【進場人數：${allpeopleInData}人】
            【離場人數：${allpeopleOutCount}人】
                `
      }

      // if(xaxisCategories.length === 1) {
      //   const data = Utils.setapexChartZero(xaxisCategories, this.activtyHourCountData)
      //   xaxisCategories = data.xaxisCategories
      //   this.activtyHourCountData = data.chartData
      // }

      // chartSetting = {...chartSetting, ...{xaxis:{categories: xaxisCategories}}} //https://github.com/apexcharts/vue-apexcharts/issues/74#issuecomment-472717678
      this.activtyHourSetting = {...chartSetting} // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
      // console.log("activtyHourCountData",this.activtyHourCountData)
      // console.log("chartSetting",chartSetting)
    },

    async searchActivities() {
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
      };
      await this.$store.dispatch("activity/getActivities", condition);
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item.time)) {
        return "-";
      }

      const time = moment(item.time);
      return `${moment(time).format("YYYY-MM-DD")} \n ${moment(time).format(
        "HH"
      )}~${moment(time).add(1, "h").format("HH")}`;
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    initTable: function () {
      this.table = $("#activity-hour").DataTable({
        responsive: true,
        aoColumns: [
          ...new Array($("#activity-hour th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: "/json/dataTableZHTW.json",
        },
        pageLength: 25,
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
  },
  async mounted() {
    this.updateTable();

    this.cctvPeopleIn =
      this.$store.getters["videoCamera/getCCTVById"]("cv99001");
    this.cctvPeopleOut =
      this.$store.getters["videoCamera/getCCTVById"]("cv99002");

    if (
      Utils.isEmptyObject(this.cctvPeopleIn) ||
      Utils.isEmptyObject(this.cctvPeopleOut)
    ) {
      // 此頁重整重新呼叫api
      await this.$store.dispatch("videoCamera/getCCTV");
      this.cctvPeopleIn =
        this.$store.getters["videoCamera/getCCTVById"]("cv99001");
      this.cctvPeopleOut =
        this.$store.getters["videoCamera/getCCTVById"]("cv99002");
    }
  },
};
</script>
<style>
.apexcharts-menu-item {
  padding: 6px 7px;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
}


#activityHourChart .apexcharts-tooltip.apexcharts-theme-light  {
  background-color: rgb(243 243 243 / 75%);
}

tbody > tr > td, tr > th {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
} /* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
} /* table不超過div */
</style>
